import type { MorningConfig } from '~~/shared/types/morning'

export function morningConfigCacheKey(tenantId?: string | null) {
  return `morning-config:${tenantId ?? 'unresolved'}`
}

export function useMorningConfig() {
  const { tenant, contextKey } = useAuth()
  const key = computed(() => `${morningConfigCacheKey(tenant.value?.id)}:${contextKey.value}`)
  return useFetch<MorningConfig>('/api/config', {
    key,
    dedupe: 'cancel',
    cache: 'no-store',
  })
}
